import { useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { builderSampleWeek } from "../../lib/metadata-builder/sample-schedule";
import { useCanvasMetadata } from "../../lib/schedule-art/canvas-state";
import { dispatchMetadataEvent, endMetadataMerge } from "../../lib/metadata-history/dispatch";
import { weekDateStyleUpdate, weekDateSample } from "../../lib/metadata-builder/date-layouts";
import { dispatchBuilderMetadata } from "../../lib/metadata-builder/edit-text";
import { useMetadataEditingStore } from "../../stores/metadata-editing-store";
import { GlobalElementPlacementControls } from "./GlobalElementPlacementControls";
import { TextStyleControls } from "./TextStyleControls";

type WeekDateElementEditorProps = { index: number };

export function WeekDateElementEditor({ index }: WeekDateElementEditorProps) {
  const metadata = useCanvasMetadata();
  const sampleDate = useMetadataBuilderStore(state => state.sampleDate);
  const element = metadata.globals[index];
  if (!element) return null;
  const path = `globals.${index}`;
  const sample = weekDateSample(element, metadata, builderSampleWeek(sampleDate));
  const style = metadata.styles[element.style];

  return (
    <div className="space-y-3" onBlurCapture={endMetadataMerge} onFocusCapture={() => {
      if (useMetadataEditingStore.getState().selected !== path) useMetadataEditingStore.getState().select(path);
    }}>
      <p className="text-lg" style={{ fontFamily: style?.font, fontWeight: style?.weight }}>{style?.capitalize ? sample.toUpperCase() : sample}</p>
      <GlobalElementPlacementControls position={element.position} rotation={element.rotation} index={index} onUpdate={dispatchMetadataEvent} />
      <TextStyleControls styleName={element.style} onChange={(patch, field, merge) => {
        const payload = weekDateStyleUpdate(metadata, index, patch, field);
        if (!payload || payload.type !== "style/set") return;
        const mergeKey = merge ? `style:${payload.name}:${field}` : undefined;
        dispatchBuilderMetadata(payload, mergeKey);
      }} />
    </div>
  );
}
